import Main from '@/views/layouts/main.vue'
import MainAssist from '@/views/layouts/mainassist.vue'

export default [
  {
    path: '/',
    name: '_home',
    redirect: '/index',
    component: Main,
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('../views/Index.vue'),
        meta: {
          title: '首页',
          showloading: false
        },
      },
      {
        path: '/uc',
        name: 'my',
        component: () => import('../views/Home.vue'),
        meta: {
          title: '我的',
          showloading: true,
        },
      },
    ],
  },
  {
    path: '/',
    name: 'mainassist',
    component: MainAssist,
    children: [
      {
        path: '/detail/:matchid',
        name: 'mdetail',
        component: () => import(/* webpackChunkName: "detail" */ '../views/match/detail.vue'),
        meta: {
          title: '详情',
          showloading: true,
        },
      },
      {
        path: '/apply/:typeid',
        name: 'apply',
        component: () => import(/* webpackChunkName: "login" */ '../views/apply/apply.vue'),
        meta: {
          title: '报名',
          showloading: true,
        },
      },
      {
        path: '/userslist',
        name: 'userslist',
        component: () => import(/* webpackChunkName: "login" */ '../views/userslist/userlist.vue'),
        meta: {
          title: '添加参赛者',
          showloading: true,
        },
      },
      {
        path: '/adduser',
        name: 'adduser',
        component: () => import(/* webpackChunkName: "login" */ '../views/adduser/adduser.vue'),
        meta: {
          title: '参赛者',
          showloading: true,
        },
      },
      {
        path: '/order/:matchid/:typeid/:rrid/:rgid',
        name: 'order',
        component: () => import(/* webpackChunkName: "login" */ '../views/order/order.vue'),
        meta: {
          title: '订单确认',
          showloading: true,
        },
      },
      {
        path: '/term/:matchid/:typeid',
        name: 'term',
        component: () => import(/* webpackChunkName: "login" */ '../views/term/term.vue'),
        meta: {
          title: '报名',
          showloading: true,
        },
      },
      {
        path: '/manage',
        name: 'manage',
        component: () => import(/* webpackChunkName: "login" */ '../views/manage/manage.vue'),
        meta: {
          title: '团队',
          showloading: true,
        },
      },
      {
        path: '/editgroup',
        name: 'editgroup',
        component: () => import(/* webpackChunkName: "login" */ '../views/editgroup/editgroup.vue'),
        meta: {
          title: '修改团队信息',
          showloading: true,
        },
      },
      {
        path: '/member',
        name: 'member',
        component: () => import(/* webpackChunkName: "login" */ '../views/member/member.vue'),
        meta: {
          title: '成员管理',
          showloading: true,
        },
      },
      {
        path: '/myregister',
        name: 'myregister',
        component: () => import(/* webpackChunkName: "login" */ '../views/myregister/myregister.vue'),
        meta: {
          title: '我的报名',
          showloading: true,
        },
      },
      {
        path: '/search',
        name: 'search',
        component: () => import(/* webpackChunkName: "login" */ '../views/search/search.vue'),
        meta: {
          title: '搜索',
          showloading: true,
        },
      },
      {
        path: '/myfavors',
        name: 'myfavors',
        component: () => import(/* webpackChunkName: "login" */ '../views/myfavors/myfavors.vue'),
        meta: {
          title: '我的收藏',
          showloading: true,
        },
      },
      {
        path: '/mycontacts',
        name: 'mycontacts',
        component: () => import(/* webpackChunkName: "login" */ '../views/mycontacts/mycontacts.vue'),
        meta: {
          title: '我的参赛卡',
          showloading: true,
        },
      },
      {
        path: '/myconedit',
        name: 'myconedit',
        component: () => import(/* webpackChunkName: "login" */ '../views/myconedit/myconedit.vue'),
        meta: {
          title: '参赛卡信息',
          showloading: true,
        },
      },
      {
        path: '/bindphone',
        name: 'bindphone',
        component: () => import(/* webpackChunkName: "login" */ '../views/bindphone/bindphone.vue'),
        meta: {
          title: '绑定手机',
          showloading: true,
        },
      },
      {
        path: '/invitemember/:matchid',
        name: 'invitemember',
        component: () => import(/* webpackChunkName: "login" */ '../views/invitemember/invitemember.vue'),
        meta: {
          title: '信息填写',
          showloading: true,
        },
      },
      {
        path: '/orderview/:matchid/:typeid/:rrid/:rgid',
        name: 'orderview',
        component: () => import(/* webpackChunkName: "login" */ '../views/orderview/orderview.vue'),
        meta: {
          title: '订单查看',
          showloading: true,
        },
      },
      {
        path: '/membersubmit',
        name: 'membersubmit',
        component: () => import(/* webpackChunkName: "login" */ '../views/membersubmit/membersubmit.vue'),
        meta: {
          title: '成员名单',
          showloading: true,
        },
      },
      {
        path: '/terms',
        name: 'terms',
        component: () => import(/* webpackChunkName: "login" */ '../views/terms/terms.vue'),
        meta: {
          title: '参赛声明',
          showloading: true,
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      title: '登录',
      showloading: false,
      noLogin: true,
    },
  },
  {
    path: '/money',
    name: 'money',
    component: () => import(/* webpackChunkName: "login" */ '../views/money/money.vue'),
    meta: {
      title: '订单',
      showloading: false,
    },
  },
  {
    path: '/mppay',
    name: 'mppay',
    component: () => import(/* webpackChunkName: "login" */ '../views/Mppay.vue'),
    meta: {
      title: '微信支付',
      showloading: true,
    },
  },
  {
    path: '/checkin',
    name: 'checkin',
    component: () => import(/* webpackChunkName: "login" */ '../views/checkin/index.vue'),
    meta: {
      title: '赛事检录/签到',
      showloading: true,
      noLogin: true,
    },
  },
  {
    path: '/checkinpc',
    name: 'checkinpc',
    component: () => import(/* webpackChunkName: "login" */ '../views/checkin/indexPC.vue'),
    meta: {
      title: '赛事检录/签到',
      showloading: true,
      noLogin: true,
    },
  },
  {
    path: '/checkinpc/detail/:id?',
    name: 'checkinpcdetail',
    component: () => import(/* webpackChunkName: "login" */ '../views/checkin/detailPC.vue'),
    meta: {
      title: '选手信息',
      showloading: true,
      noLogin: true,
    },
  },
  {
    path: '/checkin/detail/:id',
    name: 'c_detail',
    component: () => import(/* webpackChunkName: "login" */ '../views/checkin/detail.vue'),
    meta: {
      title: '选手信息',
      showloading: true,
      noLogin: true,
    },
  },
  {
    path: '/main',
    name: 'main',
    component: () => import(/* webpackChunkName: "login" */ '../views/Mppay.vue'),
    meta: {
      title: '链接汇总',
      showloading: true,
    },
  },
  {
    path: '/checkinpc/showscore/:matchid',
    name: 'checkinscore',
    component: () => import(/* webpackChunkName: "login" */ '../views/checkin/showScore.vue'),
    meta: {
      title: '选手信息',
      showloading: true,
      noLogin: true,
    },
  },
  {
    path: '/mappc',
    name: 'map-pc',
    component: () => import(/* webpackChunkName: "login" */ '../views/map/map-pc.vue'),
    meta: {
      title: '赛事地图',
      showloading: true,
      noLogin: true,
    },
  },
  {
    path: '/mapmobile',
    name: 'map-mobile',
    component: () => import(/* webpackChunkName: "login" */ '../views/map/map-mobile.vue'),
    meta: {
      title: '赛事地图',
      showloading: true,
      noLogin: true,
    },
  },
  {
    path: '/wuxing',
    name: 'wuxing',
    component: () => import(/* webpackChunkName: "wuxing" */ '../views/wuxing/blank.vue'),
    meta: {
      title: '裁判系统',
      showloading: true,
      noLogin: true,
    },
    children: [
      {
        path: '/',
        name: 'wuxing_judge',
        component: () => import(/* webpackChunkName: "wuxing" */ '../views/wuxing/index.vue'),
        meta: {
          title: '裁判系统',
          showloading: true,
          noLogin: true,
        },
      },
      {
        path: 'login',
        name: 'wuxing_login',
        component: () => import(/* webpackChunkName: "wuxing" */ '../views/wuxing/login.vue'),
        meta: {
          title: '裁判系统登录',
          showloading: true,
          noLogin: true,
        },
      },
      {
        path: 'rank',
        name: 'wuxing_rank',
        component: () => import(/* webpackChunkName: "wuxing" */ '../views/wuxing/rank.vue'),
        meta: {
          title: '成绩查看',
          showloading: true,
          noLogin: true,
        },
      },
    ],
  },
  {
    path: '/tplogin',
    name: 'tplogin',
    component: () => import(/* webpackChunkName: "login" */ '../views/tplogin'),
    meta: {
      title: '授权登录',
      showloading: true,
      noLogin: true,
    },
  },
]
